import axios from "axios";

export const uploadToSpaces = async (file, folderName) => {
  try {
    const imageName = `${folderName}${Date.now()}_${file.name}`;
    console.log("imageName: ", imageName);

    const { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}upload/presign?fileKey=${encodeURIComponent(imageName)}&fileType=${encodeURIComponent(file.type)}`
    );

    console.log("data: ", data);
    console.log("file: ", file);
    await axios.put(data.url, file, {
      headers: {
        "Content-Type": file.type,
        "x-amz-acl": "public-read",
      },
    });

    return `https://healthsy-team.sfo3.digitaloceanspaces.com/${imageName}`;
  } catch (err) {
    console.error("Image upload failed:", err);
    throw err;
  }
};
